// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-2672dcac]{fill:#afd755}.cls-2[data-v-2672dcac]{fill:#96be4b}.cls-3[data-v-2672dcac]{fill:#af6e5a}.cls-4[data-v-2672dcac]{fill:#965a50}.cls-5[data-v-2672dcac]{fill:#404040}", ""]);
// Exports
module.exports = exports;
